export default "__VITE_ASSET__BUjxLeW3__"